<button
    type="button"
    class="kss"
    (click)="onWake()"
    aria-label="Tap anywhere to start"
>
    <!-- Cycling welcome imagery (customer Quote page only) -->
    <div class="kss__bg">
        @if (showImagery) {
            @for (slide of slides; track slide; let i = $index) {
                <div
                    class="kss__slide"
                    [class.kss__slide--active]="i === index"
                    [style.backgroundImage]="'url(' + slide + ')'"
                ></div>
            }
        }
        <div class="kss__veil"></div>
        <!-- Soft colour that drifts across the whole panel for depth -->
        <div class="kss__aurora" aria-hidden="true"></div>
    </div>

    <div class="kss__inner">
        <!-- Tenant brand mark, gently breathing in and out -->
        <img
            class="kss__logo"
            [class.kss__logo--animated]="companyLogoIsAnimated"
            [src]="companyLogoSrc"
            (error)="onLogoError()"
            alt=""
            aria-hidden="true"
            draggable="false"
        />

        <!-- Page identity: which station this is -->
        <div class="kss__page">
            <h1 class="kss__page-label">{{ pageLabel }}</h1>
        </div>

        @if (pageTagline) {
            <p class="kss__tagline">{{ pageTagline }}</p>
        }

        <div class="kss__cta" aria-hidden="true">
            <span class="kss__ring"></span>
            <span class="kss__ring kss__ring--delay"></span>
            <span class="kss__hand">
                <mat-icon>touch_app</mat-icon>
            </span>
        </div>
    </div>
</button>
